// Factory for resource list-page React Query keys — the standard
// all / lists / list / details / detail hierarchy each resource currently
// hand-rolls in api/<resource>/queries.ts. The produced arrays are identical
// to the per-resource versions, so cache keys are unchanged.

export interface ResourceListQueryKeys<TParams> {
  all: readonly [string];
  lists: () => readonly [string, 'list'];
  list: (params: TParams) => readonly [string, 'list', TParams];
  details: () => readonly [string, 'detail'];
  detail: (id: number) => readonly [string, 'detail', number];
}

export function createResourceListQueryKeys<TParams>(
  resource: string,
): ResourceListQueryKeys<TParams> {
  return {
    all: [resource] as const,
    lists: () => [resource, 'list'] as const,
    list: (params: TParams) => [resource, 'list', params] as const,
    details: () => [resource, 'detail'] as const,
    detail: (id: number) => [resource, 'detail', id] as const,
  };
}
